import { type Guard } from '@capsicum/common';
import { useRouter } from '@capsicum/common-web';
import { ClaimPledgeReviewAtom } from '@capsicum/socios-core';
import { useAtomValue } from 'jotai';

import { useBaseWCPledgeGuard } from './useBaseWCPledgeGuard';

export const useWCPledgeClaimReviewGuard: Guard = () => {
	const baseGuard = useBaseWCPledgeGuard();
	const router = useRouter();
	const hasClaimReviewData = Boolean(useAtomValue(ClaimPledgeReviewAtom).claimablePledgeItems.length);

	return {
		onDenied: () => {
			if (baseGuard.status === 'denied') {
				baseGuard.onDenied();
			} else if (!hasClaimReviewData) {
				router.push('/locker-room-internationals?tab=activity');
			}
		},
		status: baseGuard.status === 'allowed' && hasClaimReviewData ? 'allowed' : 'denied'
	};
};
